/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Directory_Detail_Screenshot_OpenInputs */

const en_directory_detail_screenshot_open = /** @type {(inputs: Directory_Detail_Screenshot_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open screenshot ${i?.index}`)
};

const zh_directory_detail_screenshot_open = /** @type {(inputs: Directory_Detail_Screenshot_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`打开截图 ${i?.index}`)
};

/**
* | output |
* | --- |
* | "Open screenshot {index}" |
*
* @param {Directory_Detail_Screenshot_OpenInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_screenshot_open = /** @type {((inputs: Directory_Detail_Screenshot_OpenInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Screenshot_OpenInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_screenshot_open(inputs)
	return zh_directory_detail_screenshot_open(inputs)
});
export { directory_detail_screenshot_open as "directory.detail.screenshot_open" }